"use client";

import { Tel } from "#app/_ui/components/media/Tel";
import { hoursOnlineSupport, telOnlineSupport } from "#app/lib/company";
import { toUsaTelHref } from "#app/lib/telephone";
import { Icon } from "#ui/icon";
import { LinkButton } from "#ui/link";
import { H2, P } from "#ui/typography";

import { Segment } from "../authentication/segment";
import { useJwtSegment } from "../authentication/useJwt";

export default function Page() {
  const segment = useJwtSegment();
  const isAuthed = segment !== Segment.NotLoggedIn;

  return (
    <div className="grid grow justify-items-center p-30px">
      <div className="grid w-full max-w-850px place-content-center place-items-center gap-20px text-center md:min-h-280px md:py-30px">
        <Icon
          name="baird-maintenance-circle"
          size="baird-lg"
          palette="warning"
          className="mb-5px"
        />
        <H2 size="h5" className="leading-none">
          Oops! It looks like we ran into an error.
        </H2>
        <P size="sm" palette="neutral-subtle" className="max-w-702px">
          An unexpected error occurred while processing your request. Steps are
          being taken to resolve this issue. You may contact{" "}
          <LinkButton
            href={isAuthed ? "/contact-us" : "/tech-support"}
            variant="link"
            underline
          >
            Baird Online Support
          </LinkButton>{" "}
          or call{" "}
          <Tel href={telOnlineSupport} hrefFn={toUsaTelHref}>
            {telOnlineSupport}
          </Tel>
          , {hoursOnlineSupport} for assistance.
        </P>
        <div>
          {isAuthed ? (
            <LinkButton href="/">Go to dashboard</LinkButton>
          ) : (
            <LinkButton href="/sign-in">Sign In</LinkButton>
          )}
        </div>
      </div>
    </div>
  );
}
